import { FaceWomanShimmerIcon } from './FaceWomanShimmerIcon';

/**
 * author: Simran
 * id 97F4C885-AB98-45C3-85C7-E5DA25ECD271
 * name face-woman-shimmer
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-woman-shimmer.svg
 * tags
 * - People / Family 
 * - Photography 
 * - Health / Beauty 
 * - Account / User 
 */
export const FaceRetouchingNaturalWomanIcon = FaceWomanShimmerIcon;
export default FaceRetouchingNaturalWomanIcon